"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var date_fns_1 = require("date-fns");
var is_after_1 = (0, tslib_1.__importDefault)(require("date-fns/is_after"));
var is_before_1 = (0, tslib_1.__importDefault)(require("date-fns/is_before"));
var is_equal_1 = (0, tslib_1.__importDefault)(require("date-fns/is_equal"));
var is_same_day_1 = (0, tslib_1.__importDefault)(require("date-fns/is_same_day"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var text_1 = require("../../text");
var day_1 = require("./day");
var labels = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
function isDaySelectable(props, day) {
    var minDate = props.minDate, maxDate = props.maxDate, disableWeekends = props.disableWeekends;
    var isAfterMinDate = minDate ? (0, is_after_1.default)(day.value, minDate) : true;
    var isBeforeMaxDate = maxDate ? (0, is_before_1.default)(day.value, maxDate) : true;
    var isSameDate = (0, is_equal_1.default)(day.value, maxDate);
    var isNotWeekend = disableWeekends ? day.dayOfWeek % 6 !== 0 : true;
    return isAfterMinDate && (isBeforeMaxDate || isSameDate) && isNotWeekend;
}
function CalendarMonth(props) {
    var calendar = props.calendar, onClick = props.onClick, selectedDate = props.selectedDate;
    var days = calendar.days;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(StyledCalendar, { cellSpacing: "0", cellPadding: "0" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, labels.map(function (label) { return (react_1.default.createElement(StyledTableHeader, { key: label },
                    react_1.default.createElement(text_1.Text, { weight: 600, color: "dark" }, label))); }))),
            react_1.default.createElement("tbody", null, days.map(function (week, index) { return (react_1.default.createElement("tr", { key: index }, week.map(function (day) {
                var isSelectable = isDaySelectable(props, day);
                return (react_1.default.createElement(day_1.DayCell, { day: day, isSelected: selectedDate ? (0, is_same_day_1.default)(selectedDate, day.value) : false, key: day.value, isSelectable: isSelectable, onClick: function () {
                        if (isSelectable) {
                            if (day.isCurrentMonth === false) {
                                calendar.setMonth((0, date_fns_1.format)(day.value, 'MMMM'));
                            }
                            onClick(day.value);
                        }
                    } }));
            }))); })))));
}
exports.default = CalendarMonth;
var StyledCalendar = styled_components_1.default.table(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  border-collapse: collapse;\n  width: 100%;\n"], ["\n  border-collapse: collapse;\n  width: 100%;\n"])));
var StyledTableHeader = styled_components_1.default.th(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  height: 30px;\n  padding-top: 5px;\n"], ["\n  height: 30px;\n  padding-top: 5px;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=month.js.map